import { createSlice } from "@reduxjs/toolkit";

export const servicesSlice = createSlice({
  name: "services",
  initialState: {
    serviceCenters: {
      list: [],
      meta: {},
      totalServiceCenters:null
    }
  },
  reducers: {
    getServiceCentersRequest: () => {},
    getServiceCentersResponse: (state, action) => {
      state.serviceCenters.list = action.payload.serviceCenters ;
      state.serviceCenters.meta = action.payload.meta ;
      state.serviceCenters.totalServiceCenters = action.payload.totalServiceCenters;
    }
  },
});

export const {
  getServiceCentersRequest,
  getServiceCentersResponse,
} = servicesSlice.actions;

export default servicesSlice.reducer;
